import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";

export default async function deleteTabla(id) {
  const endpoint = localStorage.getItem("api");
  const url = endpoint + "admDynamicTable/" + id;

  try {
    const config = { method: "DELETE", headers: {} };
    const response = await fetch(url, config);
    const json = await response.json();

    if (json.message === "Se eliminó la clase correctamente") {
      alertify.set("alert", "position", "bottom-right");
      alertify.set("notifier", "delay", 5.0);
      //   actualizar(Math.floor(Math.random() * 100000))
    } else {
      alertify.set("alert", "position", "bottom-right");
      alertify.set("notifier", "delay", 5.0);
    }
  } catch (error) {
    alertify.error("Error inesperado");
  }
}
